export const Marquee = ({ text = "CROSS-BORDER FREIGHT", repeat = 6 }) => {
  const items = Array.from({ length: repeat });
  return (
    <div className="overflow-hidden border-y-2 border-[#0B192C]/10 py-6 select-none" data-testid="marquee">
      <div className="flex whitespace-nowrap animate-marquee">
        {items.concat(items).map((_, i) => (
          <span key={i} className="font-head font-black uppercase text-[7vw] leading-none tracking-tighter text-[#0B192C]/[0.08] px-8 flex items-center gap-8">
            {text}
            <span className="text-[#FF5A00]/30">/</span>
          </span>
        ))}
      </div>
    </div>
  );
};
